import React from 'react'

const RightArrowIcon = ({width, height, color}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 17 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.6654 15.7956C17.1115 15.3276 17.1115 14.6724 16.6654 14.2044L3.63648 0.351014C3.19029 -0.117005 2.47638 -0.117005 2.11942 0.351014L0.334646 2.22309C-0.111549 2.5975 -0.111549 3.34633 0.334646 3.81435L10.8648 14.9532L0.334646 26.1856C-0.111549 26.6537 -0.111549 27.3089 0.334646 27.7769L2.11942 29.649C2.47638 30.117 3.19029 30.117 3.63648 29.649L16.6654 15.7956Z"
                fill={color}/>
        </svg>
    )
}

export default RightArrowIcon;